import React, { useRef } from "react";
import Header from "../../Common/Header";
import { Card, Button, Affix } from "antd";
import { isMobileView } from "../../Common/AppHelper";
import { useNavigate } from "react-router-dom";
import AddPurchaseOrderForm from "./AddPurchaseOrderForm";

export default function AddPurchaseOrder(props) {
  const { width } = props;
  const propertyFormRef = useRef(null);

  const navigate = useNavigate();
  const discartForm = () => {
    navigate("/merchandising/purchase-order-new");
  };

  const addPurchaseOrder = () => {
    propertyFormRef.current.submit();
  };

  return (
    <>
      <Affix offsetTop={0}>
        <Card
          className="p-fixed"
          style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}
        >
          <Header
            title="Add Buyer Purchase Order"
            subTitle=""
            addLink="/"
            addText="Add New"
            actions={[
              <Button size="small" key={1} danger onClick={() => discartForm()}>
                Discard
              </Button>,
              <Button
                size="small"
                key={2}
                type="primary"
                onClick={() => addPurchaseOrder()}
              >
                Add Buyer Purchase Order
              </Button>,
            ]}
          />
        </Card>
      </Affix>

      <AddPurchaseOrderForm ref={propertyFormRef} mode="add" />
    </>
  );
}
